<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="!metadata.name.optional">
              {{ metadata.name.label }}
            </label>
            <crm-input-text
              [(value)]="unit.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div
            *ngIf="canUploadAtrium"
            class="field">
            <label
              class="font-medium"
              [class.required-field]="!metadata.atriumCode.optional">
              {{ metadata.atriumCode.label }}
            </label>
            <crm-input-text
              [(value)]="unit.atriumCode"
              [isError]="$any(errors?.atriumCode)"></crm-input-text>
            <small
              *ngIf="errors?.atriumCode"
              class="p-error">
              {{ errors.atriumCode | join }}
            </small>
          </div>

          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="!metadata.short.optional">
              {{ metadata.short.label }}
            </label>
            <crm-input-text
              [(value)]="unit.short"
              [isError]="$any(errors?.short)"></crm-input-text>
            <small
              *ngIf="errors?.short"
              class="p-error">
              {{ errors.short | join }}
            </small>
          </div>

          <div class="field">
            <label
              class="font-medium"
              [class.required-field]="!metadata.color.optional">
              {{ metadata.color.label }}
            </label>
            <div class="flex align-items-end gap-3">
              <crm-color-picker [(color)]="unit.color"></crm-color-picker>
              <div
                style="width: 50px; height: 50px; border-radius: 5px"
                [ngStyle]="{ 'background-color': unit.color }"></div>
            </div>
            <div class="p-inputgroup mt-2">
              <span class="p-inputgroup-addon">Hex</span>
              <crm-input-text
                [value]="unit.color"
                (valueChange)="changeColor($event)"
                [isError]="$any(errors?.color)"
                class="w-full"></crm-input-text>
            </div>

            <small
              *ngIf="errors?.color"
              class="p-error">
              {{ errors.color | join }}
            </small>
          </div>

          <div class="field-checkbox">
            <p-checkbox
              [(ngModel)]="unit.distributeCosts"
              [binary]="true"
              inputId="distributeCosts"></p-checkbox>
            <label [for]="'distributeCosts'">Распределять затраты</label>
          </div>

          <div
            *ngIf="unit.deleted"
            class="text-right">
            <p-tag
              severity="danger"
              value="Удалена"
              styleClass="mt-2"></p-tag>
          </div>
        </div>
      </p-card>

      <div
        class="mt-3"
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit">
        <crm-directory-common-history
          [entityName]="DirectoryCommonHistoryTypeEnum.UNIT"
          [entityId]="formStoreService.getState.forms[this.index]?.entityId"
          [apiService]="unitService">
        </crm-directory-common-history>
      </div>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success mr-2"
        (click)="saveUnit()"></button>
      <div class="flex align-items-center gap-2">
        <button
          *ngIf="(form$ | async)?.isShowDelete && !unit.deleted"
          pButton
          label="Удалить"
          class="p-button-danger p-button-text"
          (click)="deleteUnit()"></button>
        <button
          *ngIf="(form$ | async)?.isShowDelete && unit.deleted"
          pButton
          icon="pi pi-undo"
          label="Восстановить"
          class="p-button-info p-button-text"
          (click)="restoreUnit()"></button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
